module.exports = __webpack_public_path__ + "static/media/Chaloner Lucy Wardrobes.a2173219.JPG";